export function getRem() {
  return parseFloat(getComputedStyle(document.documentElement).fontSize);
}

export function getMobileMediaQuery() {
  return window.matchMedia("(max-width: 768px)").matches;
}
